import { BsEye, BsEyeSlash } from 'react-icons/bs';
import { Dispatch, FC, SetStateAction } from 'react';
import { TerritoryDates } from 'src/custom-hooks/useTerritoryDates';

type propsType = {
    clearSelection: () => void;
    selectionMode: boolean;
    setSelectionMode: Dispatch<SetStateAction<boolean>>;
    setShowActivity: Dispatch<SetStateAction<boolean>>;
    setShowBuildings: Dispatch<SetStateAction<boolean>>;
    setShowDates: Dispatch<SetStateAction<boolean>>;
    setShowFamilies: Dispatch<SetStateAction<boolean>>;
    setShowNumbers: Dispatch<SetStateAction<boolean>>;
    showActivity: boolean;
    showBuildings: boolean;
    showDates: boolean;
    showFamilies: boolean;
    showNumbers: boolean;
    territoryDates: TerritoryDates;
};

export const HTHInteractiveMapSelectors: FC<propsType> = ({
    clearSelection, selectionMode, setSelectionMode, setShowActivity,
    setShowBuildings, setShowDates, setShowFamilies, setShowNumbers,
    showActivity, showBuildings, showDates, showFamilies, showNumbers,
    territoryDates
}) => {

    return (
        <div className={'d-flex flex-wrap align-items-center justify-content-center bg-lightdark border rounded gap-2 p-2 mb-3'}>
            <button className={`btn btn-sm ${showNumbers ? 'btn-general-blue' : 'btn-outline-general-blue'} col-12 col-md`}
                onClick={() => setShowNumbers(x => !x)}
            >
                {showNumbers ?
                    <BsEyeSlash className={'me-1'} />
                    :
                    <BsEye className={'me-1'} />
                }
                {showNumbers ? 'Ocultar números' : 'Mostrar números'}
            </button>
            <button className={`btn btn-sm ${showFamilies ? 'btn-success' : 'btn-outline-success'} col-12 col-md`}
                onClick={() => setShowFamilies(x => !x)}
            >
                {showFamilies ? <BsEyeSlash className={'me-1'} /> : <BsEye className={'me-1'} />}
                {showFamilies ? 'Ocultar familias' : 'Mostrar familias'}
            </button>
            <button className={`btn btn-sm ${showDates ? 'btn-primary' : 'btn-outline-primary'} col-12 col-md`}
                onClick={() => setShowDates(x => !x)}
                disabled={!territoryDates || Object.keys(territoryDates).length === 0}
            >
                {showDates ? <BsEyeSlash className={'me-1'} /> : <BsEye className={'me-1'} />}
                {showDates ? 'Ocultar fechas' : 'Mostrar fechas'}
            </button>
            <button className={`btn btn-sm ${showActivity ? 'btn-danger' : 'btn-outline-danger'} col-12 col-md`}
                onClick={() => {
                    setSelectionMode(false);
                    setShowActivity(x => !x);
                }}
            >
                {showActivity ? <BsEyeSlash className={'me-1'} /> : <BsEye className={'me-1'} />}
                {showActivity ? 'Ocultar Actividad' : 'Mostrar Actividad'}
            </button>
            <button className={`btn btn-sm ${showBuildings ? 'btn-danger' : 'btn-outline-danger'} col-12 col-md`}
                onClick={() => {
                    setSelectionMode(false);
                    setShowBuildings(x => !x);
                }}
            >
                {showBuildings ? <BsEyeSlash className={'me-1'} /> : <BsEye className={'me-1'} />}
                {showBuildings ? 'Ocultar Edificios' : 'Mostrar Edificios'}
            </button>
            <button className={`btn btn-sm ${selectionMode ? 'btn-warning' : 'btn-outline-warning'} col-12 col-md`}
                onClick={() => {
                    setShowActivity(false);
                    setShowBuildings(false);
                    clearSelection();
                    setSelectionMode(x => !x);
                }}
            >
                {selectionMode ? 'Desactivar selección' : 'Activar selección'}
            </button>
        </div>
    )
}
